/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesSystemSecurity.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for System Security Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:58 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Roles = Loadable({
    loader: () => import('../containers/Roles/RoleListContainer'),
    loading: Loading,
});

export const RoleEdit = Loadable({
    loader: () => import('../containers/Roles/RoleEditContainer'),
    loading: Loading,
});



// WEBPACK FOOTER //
// ./src/config/routesSystemSecurity.js